"use client";

import useToggle from "@/src/hooks/useToggle";
import { FC } from "react";
import { HeaderAlertClientWrapperProps } from "../lib/type";
import { HeaderAlert } from "./HeaderAlert";

export const HeaderAlertClientWrapper: FC<HeaderAlertClientWrapperProps> = ({ title }) => {
    const { close: closeHeaderAlert, isToggled } = useToggle({
        initialState: true,
    });

    return <>{isToggled ? <HeaderAlert title={title} onClose={closeHeaderAlert} /> : null}</>;
};
